var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Divider, Grid, TextField, Typography } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Config } from '../../../api/config';
import { ProductConditionImageViewUrl, dynamicFormControlsListUrl, getPrecheckListByInstallBaseIdUrl, precheckDynamicCheckListFormUrl, productAttributeValueUrl } from '../../../api/url';
import { MuiStack } from '../../../components';
import { MuiCheckBox } from '../../../components/atoms/checkBox';
import { MuiImagePopUp } from '../../../components/atoms/imageDialogBox';
import { ImageViewCustomTabs } from '../../../components/templates/ImageViewCustomTabs';
import CustomFormFuelIndicator from '../../../components/templates/precheckCustomForm/customFormFuelIndicator';
import PrecheckCustomForm from '../../../components/templates/precheckCustomForm/precheckCustomForm';
import { APISchema, EFaultType, ESystemName, E_VehicleConditionView, LOCAL_STORAGE_KEYS, VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR } from '../../../constants';
import { downloadAttachment } from '../../../redux/commonSlice';
import { getByIdAPI, getListAPI } from '../../../redux/crudSlice';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { sortImagesByTimeStamp } from '../../../utils/utils';
function PreCheckTaskSummary(props) {
    var _this = this;
    var id = props.id, jobCardData = props.jobCardData, callApIStatus = props.callApIStatus;
    var _a = useState([]), preCheckList = _a[0], setPrecheckList = _a[1];
    var _b = useState([]), complaintsPhotographList = _b[0], setcomplaintsPhotographList = _b[1];
    var _c = useState([]), precheckDynamicList = _c[0], setPrecheckDynamicList = _c[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _d = useState(""), saRemarks = _d[0], setSaRemarks = _d[1];
    var _e = useState(false), isDrawerOpen = _e[0], setISDrawerOpen = _e[1];
    var _f = useState(""), imageURL = _f[0], setImageURL = _f[1];
    var _g = useState([]), fuelIdicatorDynamicList = _g[0], setFuelIndicatorDynamicList = _g[1];
    var _h = useState(E_VehicleConditionView.Image), selectedViewType = _h[0], setSelectedViewType = _h[1];
    var _j = useState([]), imageViewTypesTabs = _j[0], setImageViewTypesTabs = _j[1];
    var _k = useState(null), anchorEl = _k[0], setAnchorEl = _k[1];
    var dispatch = useDispatch();
    useEffect(function () {
        if (callApIStatus && jobCardData.ParentId) {
            getFuelLevel();
            getPrecheckList();
            getDynamicCheckListFormQuestions();
            if (jobCardData.ParentId) {
                getSABoxData(jobCardData.ParentId);
            }
        }
    }, [callApIStatus, jobCardData]);
    var getSABoxData = function (parentModuleDocumentId) { return __awaiter(_this, void 0, void 0, function () {
        var _responseData$payload, _responseData$payload2, _responseData$payload3, DownloadAttachmentUrl, responseData, _responseData$payload4, _responseData$payload5, _responseData$payload6, _responseData$payload7, attachmentTobeDownload, imageAttachementURLs_1, audioAttachementURLs, imageAttachmentsUrlWithMediaType1_1, audioAttachmentsUrlWithMediaType2_1, downloadImagePromise, downloadAudioPromise, sortedImages;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    DownloadAttachmentUrl = "".concat(Config.baseURL, "resource/PreJobCardDocument/");
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: "".concat(Config.baseURL, "PreJobCardDocument/").concat(parentModuleDocumentId, "/SAPreCheckComments")
                        }))];
                case 1:
                    responseData = _a.sent();
                    if (!(responseData !== null && responseData !== void 0 && (_responseData$payload = responseData.payload) !== null && _responseData$payload !== void 0 && _responseData$payload.success && responseData !== null && responseData !== void 0 && (_responseData$payload2 = responseData.payload) !== null && _responseData$payload2 !== void 0 && _responseData$payload2.data && responseData !== null && responseData !== void 0 && (_responseData$payload3 = responseData.payload) !== null && _responseData$payload3 !== void 0 && (_responseData$payload3 = _responseData$payload3.data) !== null && _responseData$payload3 !== void 0 && _responseData$payload3.SAComments)) return [3 /*break*/, 4];
                    setSaRemarks((_responseData$payload4 = responseData === null || responseData === void 0 || (_responseData$payload5 = responseData.payload) === null || _responseData$payload5 === void 0 || (_responseData$payload5 = _responseData$payload5.data) === null || _responseData$payload5 === void 0 || (_responseData$payload5 = _responseData$payload5.SAComments) === null || _responseData$payload5 === void 0 ? void 0 : _responseData$payload5.Comments) !== null && _responseData$payload4 !== void 0 ? _responseData$payload4 : '');
                    if (!((responseData === null || responseData === void 0 || (_responseData$payload6 = responseData.payload) === null || _responseData$payload6 === void 0 || (_responseData$payload6 = _responseData$payload6.data.SAComments) === null || _responseData$payload6 === void 0 || (_responseData$payload6 = _responseData$payload6.SABoxAttachments) === null || _responseData$payload6 === void 0 ? void 0 : _responseData$payload6.length) > 0)) return [3 /*break*/, 4];
                    attachmentTobeDownload = responseData === null || responseData === void 0 || (_responseData$payload7 = responseData.payload) === null || _responseData$payload7 === void 0 || (_responseData$payload7 = _responseData$payload7.data.SAComments) === null || _responseData$payload7 === void 0 ? void 0 : _responseData$payload7.SABoxAttachments;
                    imageAttachementURLs_1 = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1_1 = [];
                    audioAttachmentsUrlWithMediaType2_1 = [];
                    attachmentTobeDownload.map(function (element, index) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (element.MediaType === 1) {
                                imageAttachmentsUrlWithMediaType1_1.push(element);
                            }
                            if (element.MediaType === 2) {
                                audioAttachmentsUrlWithMediaType2_1.push(element);
                            }
                            return [2 /*return*/];
                        });
                    }); });
                    downloadImagePromise = imageAttachmentsUrlWithMediaType1_1.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                        var base64, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 2];
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, parentModuleDocumentId, DownloadAttachmentUrl)];
                                case 1:
                                    base64 = _a.sent();
                                    imageAttachementURLs_1.push({
                                        blobUrl: base64,
                                        AttachmentId: imageItem.AttachmentId,
                                        isAlreadyUploaded: true,
                                        _ts: imageItem._ts,
                                        file: null
                                    });
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.log("error", error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    downloadAudioPromise = audioAttachmentsUrlWithMediaType2_1.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                        var base64, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 2];
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, parentModuleDocumentId, DownloadAttachmentUrl)];
                                case 1:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push({
                                        audioBlobUrl: base64,
                                        AttachmentId: imageItem.AttachmentId,
                                        isAlreadyUploaded: true
                                    });
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _a.sent();
                                    console.log("error", error_2);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(downloadImagePromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadAudioPromise)];
                case 3:
                    _a.sent();
                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs_1);
                    setcomplaintsPhotographList(sortedImages);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getFuelLevel = function () { return __awaiter(_this, void 0, void 0, function () {
        var productAttributeBody, productAttributeResult, fuelAttributeValue, requestBody, QuestionsResponse, QuestionsList, questionsAnswers_1, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!jobCardData) return [3 /*break*/, 4];
                    productAttributeBody = {
                        "ProductId": jobCardData !== null && jobCardData !== void 0 && jobCardData.ProductId ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.ProductId : jobCardData !== null && jobCardData !== void 0 && jobCardData.ProductId ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.ProductId : ""
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: productAttributeValueUrl,
                            request: productAttributeBody
                        }))];
                case 1:
                    productAttributeResult = _a.sent();
                    if (!(productAttributeResult.payload.value.success && productAttributeResult.payload.value.data)) return [3 /*break*/, 4];
                    fuelAttributeValue = productAttributeResult.payload.value.data.Value;
                    if (!fuelAttributeValue) return [3 /*break*/, 4];
                    requestBody = {
                        "SystemName": "FuelUsed-".concat(fuelAttributeValue),
                        "ProductId": jobCardData !== null && jobCardData !== void 0 && jobCardData.ProductId ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.ProductId : jobCardData !== null && jobCardData !== void 0 && jobCardData.ProductId ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.ProductId : "",
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: requestBody
                        }))];
                case 2:
                    QuestionsResponse = _a.sent();
                    if (!QuestionsResponse.payload.value.success) return [3 /*break*/, 4];
                    QuestionsList = QuestionsResponse.payload.value.data;
                    return [4 /*yield*/, getPrecheckAnswersByModelId()];
                case 3:
                    questionsAnswers_1 = _a.sent();
                    result = QuestionsList.map(function (questionGroupItem) {
                        if (questionGroupItem.Questions && questionGroupItem.Questions.length > 0) {
                            var SortedQuestionsBySequence = __spreadArray([], questionGroupItem.Questions, true).sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, questionGroupItem), {}, {
                                Questions: SortedQuestionsBySequence.map(function (questionItem) {
                                    // const questionControlType = controlTypesList.find((item: any) => item.id === questionItem.ControlId);
                                    var questionAnswerItem = questionsAnswers_1.find(function (item) { return item.QuestionId === questionItem.QuestionId; });
                                    return _objectSpread(_objectSpread({}, questionItem), {}, {
                                        // ControlName: questionControlType && questionControlType.DisplayName ? questionControlType.DisplayName : '',
                                        ResponseValue: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue : ''
                                    });
                                })
                            });
                        }
                    });
                    setFuelIndicatorDynamicList(result);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getPrecheckList = function () { return __awaiter(_this, void 0, void 0, function () {
        var productId, precheckListResult, _precheckListResult$p, _precheckListResult$p2, _data$ProductConditio, mastersItemsList, AlhpabeticallySortedMasterList, savedItemsList_1, newArray_1, viewIdMap_1, data, _data$ProductConditio2, downloadImagePromise, final;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    productId = jobCardData !== null && jobCardData !== void 0 && jobCardData.ProductId ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.ProductId : jobCardData !== null && jobCardData !== void 0 && jobCardData.ProductId ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.ProductId : "";
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getPrecheckListByInstallBaseIdUrl(productId)
                        }))];
                case 1:
                    precheckListResult = _a.sent();
                    if (!(precheckListResult !== null && precheckListResult !== void 0 && precheckListResult.payload.success && precheckListResult !== null && precheckListResult !== void 0 && precheckListResult.payload.data)) return [3 /*break*/, 4];
                    mastersItemsList = precheckListResult !== null && precheckListResult !== void 0 && (_precheckListResult$p = precheckListResult.payload) !== null && _precheckListResult$p !== void 0 && (_precheckListResult$p = _precheckListResult$p.data) !== null && _precheckListResult$p !== void 0 && _precheckListResult$p.ProductConditionCheckListItemList ? __spreadArray([], (precheckListResult === null || precheckListResult === void 0 || (_precheckListResult$p2 = precheckListResult.payload) === null || _precheckListResult$p2 === void 0 || (_precheckListResult$p2 = _precheckListResult$p2.data) === null || _precheckListResult$p2 === void 0 ? void 0 : _precheckListResult$p2.ProductConditionCheckListItemList), true) : [];
                    AlhpabeticallySortedMasterList = mastersItemsList.sort(function (a, b) { return a.Question.localeCompare(b.Question); });
                    return [4 /*yield*/, getProductContitionValues()];
                case 2:
                    savedItemsList_1 = _a.sent();
                    newArray_1 = [];
                    AlhpabeticallySortedMasterList.forEach(function (item) {
                        var exists = savedItemsList_1.some(function (existItem) { return existItem.ProductConditionCheckListItemId === item.ProductConditionCheckListItemId; });
                        if (exists) {
                            var matchedReqItem_1 = savedItemsList_1.find(function (existItem) { return existItem.ProductConditionCheckListItemId === item.ProductConditionCheckListItemId; });
                            var images = [];
                            var newItem = {
                                "ProductConditionCheckListItemId": item.ProductConditionCheckListItemId,
                                "Question": item.Question,
                                "Answers": item.Answers.map(function (answer) { return _objectSpread(_objectSpread({}, answer), {}, {
                                    defaultValue: answer.Key === matchedReqItem_1.AnswerKey
                                }); }),
                                "ImageXPostion": item.ImageXPostion,
                                "ImageYPostion": item.ImageYPostion,
                                "ProductConditionCheckListId": item.ProductConditionCheckListId,
                                "ProductConditionViewId": item.ProductConditionViewId,
                                "Remark": matchedReqItem_1.Remarks,
                                images: images
                            };
                            newArray_1.push(newItem);
                        }
                        else {
                            newArray_1.push(item);
                        }
                    });
                    setPrecheckList(newArray_1);
                    viewIdMap_1 = {};
                    data = precheckListResult === null || precheckListResult === void 0 ? void 0 : precheckListResult.payload.data;
                    // Grouping objects by ProductConditionViewId
                    newArray_1.forEach(function (item) {
                        var viewId = item.ProductConditionViewId;
                        if (viewId) {
                            if (!viewIdMap_1[viewId]) {
                                viewIdMap_1[viewId] = [];
                            }
                            viewIdMap_1[viewId].push(item);
                        }
                    });
                    if (!(data !== null && data !== void 0 && data.ProductConditionViewList && Array.isArray(data === null || data === void 0 ? void 0 : data.ProductConditionViewList) && (data === null || data === void 0 || (_data$ProductConditio = data.ProductConditionViewList) === null || _data$ProductConditio === void 0 ? void 0 : _data$ProductConditio.length) > 0)) return [3 /*break*/, 4];
                    downloadImagePromise = data === null || data === void 0 || (_data$ProductConditio2 = data.ProductConditionViewList) === null || _data$ProductConditio2 === void 0 ? void 0 : _data$ProductConditio2.map(function (viewItem) { return __awaiter(_this, void 0, void 0, function () {
                        var ImageAttachment, base64, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    ImageAttachment = "";
                                    if (!viewItem.UploadAttachementId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(viewItem.UploadAttachementId, viewItem.ProductConditionViewId, ProductConditionImageViewUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    ImageAttachment = base64;
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error("error", error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/, _objectSpread(_objectSpread({}, viewItem), {}, {
                                        ImageAttachment: ImageAttachment,
                                        checkListItems: viewIdMap_1[viewItem.ProductConditionViewId] || []
                                    })];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(downloadImagePromise)];
                case 3:
                    final = _a.sent();
                    setImageViewTypesTabs(final);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getProductContitionValues = function () { return __awaiter(_this, void 0, void 0, function () {
        var _jobCardData$ParentId, updatedPayload, precheckListResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedPayload = {
                        EstimateId: (_jobCardData$ParentId = jobCardData.ParentId) !== null && _jobCardData$ParentId !== void 0 ? _jobCardData$ParentId : "",
                        SystemName: "ProductConditionCheckListItem"
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL + APISchema.Estimate, "/InspectionProductContitionValues"),
                            request: updatedPayload
                        }))];
                case 1:
                    precheckListResult = _a.sent();
                    if (precheckListResult.payload.success && precheckListResult.payload.data) {
                        return [2 /*return*/, precheckListResult.payload.data.InspectionValues];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getControlsList = function () { return __awaiter(_this, void 0, void 0, function () {
        var controlListForm;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "",
                        url: dynamicFormControlsListUrl
                    }))];
                case 1:
                    controlListForm = _a.sent();
                    if (controlListForm.payload.success) {
                        return [2 /*return*/, controlListForm.payload.data];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getPrecheckAnswersByModelId = function () { return __awaiter(_this, void 0, void 0, function () {
        var _jobCardData$ParentId2, apiRequestPayload, answersResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiRequestPayload = {
                        EstimateId: (_jobCardData$ParentId2 = jobCardData.ParentId) !== null && _jobCardData$ParentId2 !== void 0 ? _jobCardData$ParentId2 : ""
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL + APISchema.Estimate, "/InspectionPreCheckList"),
                            request: apiRequestPayload
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success) {
                        return [2 /*return*/, answersResponse.payload.data.Options];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getDynamicCheckListFormQuestions = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestBody, QuestionsResponse, controlTypesList_1, questionsAnswers_2, QuestionsList, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "SystemName": ESystemName.Estimate,
                        "ProductId": jobCardData !== null && jobCardData !== void 0 && jobCardData.ProductId ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.ProductId : jobCardData !== null && jobCardData !== void 0 && jobCardData.ProductId ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.ProductId : "",
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: requestBody
                        }))];
                case 1:
                    QuestionsResponse = _a.sent();
                    if (!QuestionsResponse.payload.value.success) return [3 /*break*/, 4];
                    return [4 /*yield*/, getControlsList()];
                case 2:
                    controlTypesList_1 = _a.sent();
                    return [4 /*yield*/, getPrecheckAnswersByModelId()];
                case 3:
                    questionsAnswers_2 = _a.sent();
                    QuestionsList = QuestionsResponse.payload.value.data;
                    result = QuestionsList.map(function (questionGroupItem) {
                        if (questionGroupItem.Questions && questionGroupItem.Questions.length > 0) {
                            var SortedQuestionsBySequence = __spreadArray([], questionGroupItem.Questions, true).sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, questionGroupItem), {}, {
                                Questions: SortedQuestionsBySequence.map(function (questionItem) {
                                    var questionControlType = controlTypesList_1.find(function (item) { return item.id === questionItem.ControlId; });
                                    var questionAnswerItem = questionsAnswers_2.find(function (item) { return item.QuestionId === questionItem.QuestionId; });
                                    return _objectSpread(_objectSpread({}, questionItem), {}, {
                                        ControlName: questionControlType && questionControlType.DisplayName ? questionControlType.DisplayName : '',
                                        ResponseValue: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue : ''
                                    });
                                })
                            });
                        }
                    });
                    setPrecheckDynamicList(result);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getChecked = function (dataArray, faultType) {
        var scratchObject = dataArray.find(function (item) { return item.Key === faultType; });
        if (scratchObject) {
            var isScratchDefaultValueTrue = scratchObject.defaultValue;
            return isScratchDefaultValueTrue;
        }
        else {
            return false;
        }
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    var handleClose = function () {
        setImageURL("");
        setISDrawerOpen(false);
    };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        paddingTop: 2,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        paddingRight: 1
    }, /*#__PURE__*/ React.createElement(CustomFormFuelIndicator, {
        data: fuelIdicatorDynamicList,
        onChangeList: function (list) { return setFuelIndicatorDynamicList(list); },
        isDisabled: true,
        isDataUpdated: function (value) { }
    })), /*#__PURE__*/ React.createElement(Divider, null), (preCheckList === null || preCheckList === void 0 ? void 0 : preCheckList.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t("Vehicle condition"))), selectedViewType === E_VehicleConditionView.List && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        borderRadius: '8px',
        bgcolor: '#F4F7FA',
        padding: 2,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Scratch"), ": "), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "S")), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Damage"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "D")), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Missing"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "M")))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        paddingX: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '70%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, t("Section"))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "S")), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "D")), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "M"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        width: '100%',
        paddingX: 1
    }, preCheckList.map(function (option, index) { /*#__PURE__*/ return React.createElement(MuiStack, {
        key: index,
        width: '100%',
        alignItems: 'center',
        borderBottom: '1px solid #DEE4EB',
        paddingTop: index === 0 ? 0 : 1,
        paddingBottom: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '70%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4"
    }, option.Question)), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        id: "scratch-checkbox",
        sx: {
            "& .MuiCheckbox-root": {
                padding: 0
            }
        },
        checkBoxValue: getChecked(option.Answers, EFaultType.Scratch),
        disabled: true
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        id: "damage-checkbox",
        sx: {
            "& .MuiCheckbox-root": {
                padding: 0
            }
        },
        checkBoxValue: getChecked(option.Answers, EFaultType.Damage),
        disabled: true
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        id: "missing-checkbox",
        sx: {
            "& .MuiCheckbox-root": {
                padding: 0
            }
        },
        checkBoxValue: getChecked(option.Answers, EFaultType.Missing),
        disabled: true
    }))); }))), selectedViewType === E_VehicleConditionView.Image && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        borderRadius: '8px',
        bgcolor: '#F4F7FA',
        padding: 2,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Scratch"), ": "), /*#__PURE__*/ React.createElement("div", {
        style: {
            borderRadius: "50%",
            height: "16px",
            width: "16px",
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.SCRATCH
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Damage"), ":"), /*#__PURE__*/ React.createElement("div", {
        style: {
            borderRadius: "50%",
            height: "16px",
            width: "16px",
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.DAMAGE
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Missing"), ":"), /*#__PURE__*/ React.createElement("div", {
        style: {
            borderRadius: "50%",
            height: "16px",
            width: "16px",
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.MISSING
        }
    })))), /*#__PURE__*/ React.createElement(ImageViewCustomTabs, {
        variant: "h3",
        items: imageViewTypesTabs,
        isDisabled: true
        // handleConditionChange={handleImageViewConditionChange}
        // handleRemoveCondition={handleRemoveImageViewCondition}
    }))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(PrecheckCustomForm, {
        data: precheckDynamicList,
        isDisabled: true
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        paddingBottom: 5,
        direction: "column",
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t('Service advisor observations')), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        justifyContent: "center",
        bgcolor: 'white',
        borderRadius: '8px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: "8px 8px 0px 0px"
        },
        width: "100%"
    }, /*#__PURE__*/ React.createElement(TextField, {
        id: "multiline-input-sa-observation",
        placeholder: t('Enter a description...'),
        multiline: true,
        rows: 3,
        fullWidth: true,
        value: saRemarks,
        sx: {
            "& fieldset": {
                border: 'none'
            }
        },
        style: {
            margin: 0
        },
        disabled: true
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: "0px 0px 8px 8px"
        },
        width: "100%"
    }, complaintsPhotographList && /*#__PURE__*/ React.createElement(MuiStack, {
        display: 'flex',
        padding: 0.5
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        width: '100%'
    }, complaintsPhotographList === null || complaintsPhotographList === void 0 ? void 0 : complaintsPhotographList.map(function (imgItem, idx) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        xs: 4,
        sm: 4,
        md: 4,
        lg: 2.5,
        gap: '16px'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: imgItem === null || imgItem === void 0 ? void 0 : imgItem.blobUrl,
        id: "downloadCustomerImg" + idx,
        alt: "Image ".concat(idx + 1),
        style: {
            width: '72px',
            height: '72px',
            borderRadius: '8px',
            position: 'relative'
        },
        onClick: function () { return handleClickImage(imgItem === null || imgItem === void 0 ? void 0 : imgItem.blobUrl); }
    })))); })))), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    }))));
}
export default PreCheckTaskSummary;
